import { render, staticRenderFns } from "./printSmallAccountReceiptList.vue?vue&type=template&id=573a2060&scoped=true"
import script from "./printSmallAccountReceiptList.vue?vue&type=script&lang=js"
export * from "./printSmallAccountReceiptList.vue?vue&type=script&lang=js"
import style0 from "./printSmallAccountReceiptList.vue?vue&type=style&index=0&id=573a2060&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573a2060",
  null
  
)

export default component.exports